

import custom_api_func from "./axios_api_func";

function senteventdata(event_name,event_desc='',envent_id='') {

  const user_email_id = localStorage.getItem('useremail');
    
    var formData_x = new FormData();
    formData_x.append('user_email_id',user_email_id);
    formData_x.append('event_name', event_name);
    formData_x.append('event_desc', event_desc);
  
    custom_api_func.post(`api/create_event`,formData_x)

    }

export default senteventdata;